export const capitalizeFirstLetter = (text: string) => {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
};

const removeEmojis = (text: string) => {
    return text.replace(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF\u0023-\u0039]\uFE0F?|[\u200D\u20E3\u3297\u3299]\uFE0F?|[\u00A9\u00AE\u303D\u3030\u2B50\u2B55\u231A\u231B\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FD\u25FE\u00A9\u00AE\u303D\u3030\u2B50\u2B55\u231A\u231B\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FD\u25FE])+|\uD83D[\uDC00-\uDFFF]/g,
        '',
    );
};

export const getFirstWord = (text: string, caps: boolean = false): string => {
    if (!text) return '';

    const removeUnwantedSegments = (input: string): string => {
        let result = input.replace(/::\[Reply\]/gi, '');
        result = result.replace(/@\w+/g, '');
        result = result.replace(/\d{2}:\d{2}:\d{2}/g, '');
        result = result.replace(/\[.*?\]/g, '');
        result = result.replace(/[^\w\s]|_/g, '');
        return result.trim();
    };

    const cleanText = removeEmojis(removeUnwantedSegments(text));

    let words = cleanText.split(/\s+/).filter((word) => word.length > 0);

    words = words.filter((word) => word.length > 1);

    let firstWord = '';

    if (cleanText.toLowerCase().startsWith('just in')) {
        const wordsAfterKeyword = words.slice(2);
        firstWord = wordsAfterKeyword[0] || '';
    } else if (cleanText.toLowerCase().startsWith('breaking')) {
        const wordsAfterKeyword = words.slice(1);
        firstWord = wordsAfterKeyword[0] || '';
    } else if (cleanText.toLowerCase().startsWith('rt')) {
        const wordsAfterKeyword = words.slice(1);
        firstWord = wordsAfterKeyword[0] || '';
    } else {
        firstWord = words[0] || '';
    }

    return caps ? firstWord.toUpperCase() : firstWord;
};

export const removeDoubleStar = (text: string) => {
    return text.replaceAll('*', '');
};
